// Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Components
import Stories from './stories/stories';
import CallToAction from './callToAction/callToAction';

// Styles
import SuccessStoriesStyles from './successStories.styles';

export default function SuccessStories({ layout }) {
  return (
    <SuccessStoriesStyles>
      <Stories />

      {!!layout?.displayCallToAction && (
        <CallToAction
          heading={layout?.callToActionHeading}
          text={layout?.callToActionText}
          buttons={layout?.callToActionButtons}
        />
      )}
    </SuccessStoriesStyles>
  );
}

SuccessStories.propTypes = {
  layout: PropTypes.shape({
    displayCallToAction: PropTypes.bool,
    callToActionHeading: PropTypes.string,
    callToActionText: PropTypes.string,
    callToActionButtons: PropTypes.arrayOf(PropTypes.shape({})),
  }),
};

SuccessStories.defaultProps = {
  layout: {},
};
